import * as React from 'react';
export var NotificationCard = React.forwardRef(function (_a, ref) {
    var title = _a.title, actions = _a.actions, children = _a.children, className = _a.className;
    return (React.createElement("div", { className: "feed-card ".concat(className || ''), ref: ref },
        React.createElement("div", { className: "feed-card-header" },
            React.createElement("div", { className: "feed-card-header-title" }, title),
            React.createElement("div", { className: "feed-card-header-actions" }, actions)),
        React.createElement("div", { className: "feed-card-body" }, children)));
});
//# sourceMappingURL=index.js.map